import {CartData} from "./CartProcessor";

/**
 * The line "In your cart: N items · Subtotal X" the format dialogs show.
 *
 * The texts come from the data attributes of the element, so the script
 * does not need translations of its own.
 */
export class CartFeedback {
    static SELECTOR = '.eventgallery-cart-feedback';

    static update(root: ParentNode, data: CartData | null) {
        const box: HTMLElement = root.querySelector(CartFeedback.SELECTOR);
        if (!box || !data) {
            return;
        }
        const text: HTMLElement = box.querySelector('.cart-feedback-text');
        if (!text) {
            return;
        }

        let count = data.summary ? data.summary.itemCount : 0;
        const subtotal = data.summary ? data.summary.subtotal : '';
        if (!data.summary && Array.isArray(data.cart)) {
            count = data.cart.reduce((sum: number, item: any) => sum + (parseInt(item.count) || 0), 0);
        }

        if (count > 0) {
            text.textContent = (box.getAttribute('data-template') || '')
                .replace('{count}', String(count))
                .replace('{subtotal}', subtotal);
        } else {
            text.textContent = box.getAttribute('data-empty') || '';
        }
    }
}
